import { categories } from '@/mocks/siteData';
import { Link } from 'react-router-dom';

export default function CategorySection() {
  const catImages: Record<string, string> = {
    movie: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20red%20velvet%20seats%20and%20large%20projection%20screen%2C%20warm%20golden%20lighting%2C%20luxurious%20atmosphere%2C%20elegant%20composition%2C%20classic%20film%20aesthetic&width=800&height=500&seq=cat-movie&orientation=landscape',
    tv: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20large%20modern%20TV%20screen%20showing%20drama%20series%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%20setting%2C%20home%20entertainment%20aesthetic%2C%20relaxing%20evening%20atmosphere&width=800&height=500&seq=cat-tv&orientation=landscape',
    variety: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20studio%20with%20bright%20stage%20lights%20and%20dynamic%20set%20design%2C%20entertainment%20show%20atmosphere%2C%20cheerful%20vibrant%20colors%2C%20professional%20broadcast%20environment%2C%20energetic%20composition&width=800&height=500&seq=cat-variety&orientation=landscape',
    anime: 'https://readdy.ai/api/search-image?query=Artistic%20animation%20studio%20workspace%20with%20drawing%20tablets%20and%20character%20sketches%2C%20creative%20atmosphere%2C%20vibrant%20color%20palette%2C%20Japanese%20and%20Chinese%20anime%20style%20inspiration%2C%20warm%20artistic%20lighting&width=800&height=500&seq=cat-anime&orientation=landscape',
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            海量资源，精彩分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            电影、电视剧、综艺、动漫全覆盖，找到你喜欢的每一部作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg h-48 md:h-56 cursor-pointer"
            >
              <img
                src={catImages[cat.slug] || catImages.movie}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${cat.icon} text-background-50 text-lg`} />
                  </div>
                  <h3 className="text-lg font-bold font-heading text-background-50">{cat.name}</h3>
                </div>
                <p className="text-xs text-background-200">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}